import { Box, Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../shared/components/Input';
import { Button } from '../../../../shared/components/button/Button';
import Divider from '@mui/material/Divider';

interface ModalCancelarProps {
  open: boolean;
  modalTitulo: string;
  onClose: () => void;
  formCancelarCartaCorrecao: any;
}

export const ModalCancelar = ({
  open,
  onClose,
  formCancelarCartaCorrecao,
  modalTitulo,
}: ModalCancelarProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={'flex items-center justify-center'}
    >
      <Box
        className={
          'flex flex-col items-center justify-center rounded-lg bg-white p-4 m-auto border-b w-2/6'
        }
      >
        <Typography className={'text-2xl font-bold'}>{modalTitulo}</Typography>
        <Divider className={'w-full pt-4'} />

        <form
          className={'flex flex-col gap-4 w-full pt-8'}
          autoComplete='off'
          onSubmit={formCancelarCartaCorrecao.handleSubmit}
          name='cancelar-notafiscal'
        >
          <div className="'grid grid-cols-3 gap-4">
            <div className={'col-span-3 flex flex-col gap-2'}>
              <div className={'flex flex-row gap-2'}>
                <p className={'text-sm font-bold'}>ID:</p>
                <p className={'text-sm'}>
                  {formCancelarCartaCorrecao.values.nfe_id}
                </p>
              </div>
              <div className={'flex flex-row gap-2'}>
                <p className={'text-sm font-bold'}>Número NF:</p>
                <p className={'text-sm'}>
                  {formCancelarCartaCorrecao.values.ide_n_nf}
                </p>
              </div>
            </div>
            <div className={'col-span-3 mt-6'}>
              <Input
                label='Justificativa'
                className='col-span-3'
                name='justificativa'
                handleBlur={formCancelarCartaCorrecao.handleBlur}
                handleChange={formCancelarCartaCorrecao.handleChange}
                value={formCancelarCartaCorrecao.values.Codigo}
                error={
                  formCancelarCartaCorrecao.touched.justificativa &&
                  formCancelarCartaCorrecao.errors.justificativa
                    ? formCancelarCartaCorrecao.errors.justificativa
                    : ''
                }
                hasError={
                  !!(
                    formCancelarCartaCorrecao.touched.justificativa &&
                    formCancelarCartaCorrecao.errors.justificativa
                  )
                }
              />
              <div className={'col-span-3 flex justify-end gap-4 mt-8'}>
                <Button
                  variant='primary'
                  className={'w-1/4'}
                  onClick={onClose}
                  title={'Fechar'}
                />
                <Button
                  variant={'success'}
                  type='submit'
                  className={'w-1/4'}
                  title={'Enviar'}
                />
              </div>
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
};
